<script setup lang="ts">
import { VersionCheckToast } from '@marketspark/ui';
import { RouterView } from 'vue-router';

const appVersion = import.meta.env.VITE_APP_VERSION;
</script>

<template>
  <RouterView />
  <VersionCheckToast :current-version="appVersion" />
</template>
